import { GET_FRAIS_PORT } from '../../../../domain/commande/getFraisPort';
import { CommandeStateUpdate } from '../../../../types/commande/formatUpdateCommande';
import { sanitizeCalul } from '../../../../helpers/number/sanitizeCalul';
import { UpdateCML } from '../../../../types/commandeLine/commandeLine.def';
import { ID } from '../../../../types/typeDef';
import { TOTAL_COMMANDE_A_PAYER } from '../../../../helpers/commande/totalCommandeAPayer';

export const calculTotalNoPort = (commandelines: UpdateCML[]): number =>
  sanitizeCalul(
    commandelines.reduce((a, c) => {
      if (!c.produit) return null;
      const lineCalc = c.quantite * c.produit.ttcPrice;
      return a + lineCalc;
    }, 0)
  );

type HorsLyceeFieldName = 'livraisonhorslycee' | string;
export const getHorsLycee = (
  name: HorsLyceeFieldName,
  value,
  livraisonhorslycee: boolean
): boolean => (name === 'livraisonhorslycee' ? value : livraisonhorslycee);

const supprCML = (
  commandelines: UpdateCML[],
  cmlToDelete: ID[],
  i
): { commandelines: UpdateCML[]; cmlToDelete: ID[] } => {
  const newCommandelines = [];
  commandelines.forEach((cml, ind) => {
    if (i !== ind) return newCommandelines.push(cml);
  });
  const newCmlToDelete = [...cmlToDelete, commandelines[i].id];

  return { commandelines: newCommandelines, cmlToDelete: newCmlToDelete };
};

const addCML = (
  commandelines: UpdateCML[],
  value
): { commandelines: UpdateCML[] } => {
  const newCommandelines = [
    ...commandelines,
    {
      quantite: 1,
      totalLine: value.ttcPrice,
      produit: { id: value.id, ttcPrice: value.ttcPrice, name: value.name }
    }
  ];
  return { commandelines: newCommandelines };
};

const updateCML = (
  commandelines: UpdateCML[],
  name,
  value,
  i
): { commandelines: UpdateCML[] } => {
  const newArray = [];
  commandelines.forEach((cml, ind) => {
    if (i !== ind) return newArray.push(cml);
    let totalLine = commandelines[i].totalLine;
    if (name === 'quantite')
      totalLine = commandelines[i].produit.ttcPrice * value;
    return newArray.push({
      ...commandelines[i],
      [name]: value,
      totalLine: totalLine
    });
  });
  return { commandelines: newArray };
};

export const getCommandelines = (
  name: string,
  value: unknown,
  cmdState: CommandeStateUpdate,
  i: number
): CommandeStateUpdate => {
  let res: {
    commandelines: UpdateCML[];
    cmlToDelete?: ID[];
  };
  if (name === 'suppr') {
    res = supprCML(cmdState.commandelines, cmdState.cmlToDelete, i);
  } else if (name === 'add') {
    res = addCML(cmdState.commandelines, value);
  } else {
    res = updateCML(cmdState.commandelines, name, value, i);
  }

  const totalNoPort = calculTotalNoPort(res.commandelines);

  return {
    ...cmdState,
    ...res,
    totalNoPort,
    commande: {
      ...cmdState.commande,
      prixTotal: TOTAL_COMMANDE_A_PAYER(
        totalNoPort,
        getHorsLycee(name, value, cmdState.client.values.livraisonhorslycee),
        cmdState.commande.customerContributedToTheOng
      )
    },
    prixTotal: TOTAL_COMMANDE_A_PAYER(
      totalNoPort,
      getHorsLycee(name, value, cmdState.client.values.livraisonhorslycee),
      cmdState.commande.customerContributedToTheOng
    ),
    currentFraisPort: GET_FRAIS_PORT(
      totalNoPort,
      getHorsLycee(name, value, cmdState.client.values.livraisonhorslycee)
    )
  };
};
